import {useGetCurrentWorkspaceId} from "@tinct/core-workspace";
import {UpdateValueAndMessagingForm} from "../../../forms/update-value-and-messaging-form";

export const EditBrandValueAndMessagingTab = () => {

  const workspaceId = useGetCurrentWorkspaceId();

  return <UpdateValueAndMessagingForm organizationId={workspaceId} />
}
